import { z } from 'zod';

export const PresignRequestSchema = z.object({
  fileName: z.string().min(1).max(255),
  mimeType: z.enum(['image/jpeg', 'image/png', 'image/webp']),
  fileSize: z.number().int().positive().max(10 * 1024 * 1024),
});

export const PhotoConfirmSchema = z.object({
  s3Key: z.string().min(1),
  thumbnailS3Key: z.string().optional(),
  fileName: z.string().min(1).max(255),
  fileSize: z.number().int().positive(),
  mimeType: z.enum(['image/jpeg', 'image/png', 'image/webp']),
  width: z.number().int().positive().optional(),
  height: z.number().int().positive().optional(),
  descripcion: z.string().max(500).optional(),
});

export type PresignRequest = z.infer<typeof PresignRequestSchema>;
export type PhotoConfirm = z.infer<typeof PhotoConfirmSchema>;
